<template>
  <div>
    <error-content code="Sorry！" :desc="$t('system::common::no_authority')" :src="src">
      <template slot="btn_back" v-if="authorizationCode">
        <div class="auth-code">专属授权码：{{ authorizationCode }}</div>
      </template>
    </error-content>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import errorContent from './error-content.vue'
export default {
  name: 'authority',
  components: {
    errorContent
  },
  data() {
    return {
      src: require('@/assets/images/authority.png')
    }
  },
  computed: {
    authorizationCode() {
      return Cookies.get('authorizationCode') || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-code {
  padding: 17px 42px;
  background: #fff;
  color: #2A69FF;
  margin-top: 24px;
}
</style>
